
import { verifyRecaptchaAndSubmit, prepareFormData } from './form-processor';

/**
 * Handles the form submission process through a Supabase Edge Function 
 * that sends emails via Resend
 */
export const sendToSalesforce = async (formData: Record<string, any>, formType: 'contact' | 'booking') => {
  console.log(`Processing ${formType} form data:`, {
    formType,
    hasName: !!formData.name,
    hasEmail: !!formData.email
  });
  
  // Prepare the form data with additional tracking information
  const enhancedData = prepareFormData(formData, formType);
  
  // Send to our Supabase function for email submission
  return await verifyRecaptchaAndSubmit(enhancedData);
};

// Re-export all utility functions
export * from './api-client';
export * from './response-parser';
export * from './form-processor';
